// Generated by Melange

import * as Curry from "melange.js/curry.js";
import * as Stdlib__Format from "melange/format.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function varint(v) {
  return {
    TAG: /* Varint */ 0,
    _0: v
  };
}

function varint_unboxed(v) {
  return {
    TAG: /* Varint_unboxed */ 1,
    _0: v
  };
}

function fixed_32_bit(v) {
  return {
    TAG: /* Fixed_32_bit */ 4,
    _0: v
  };
}

function fixed_64_bit(v) {
  return {
    TAG: /* Fixed_64_bit */ 2,
    _0: v
  };
}

function length_delimited(offsetOpt, length, data) {
  const offset = offsetOpt !== undefined ? offsetOpt : 0;
  const length$1 = Stdlib__Option.value(length, data.length - offset | 0);
  return {
    TAG: /* Length_delimited */ 3,
    _0: {
      offset: offset,
      length: length$1,
      data: data
    }
  };
}

function string_of_field_type(param) {
  switch (param) {
    case /* Varint */ 0 :
      return "Varint";
    case /* Fixed64 */ 1 :
      return "Fixed64";
    case /* Fixed32 */ 2 :
      return "Fixed32";
    case /* Length_delimited */ 3 :
      return "Length_delimited";
  }
}

function pp(fmt, a0) {
  switch (a0.TAG) {
    case /* Varint */ 0 :
      Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Char_literal */ 12,
          _0: /* '(' */40,
          _1: {
            TAG: /* Formatting_gen */ 18,
            _0: {
              TAG: /* Open_box */ 1,
              _0: {
                TAG: /* Format */ 0,
                _0: {
                  TAG: /* String_literal */ 11,
                  _0: "<2>",
                  _1: /* End_of_format */ 0
                },
                _1: "<2>"
              }
            },
            _1: {
              TAG: /* String_literal */ 11,
              _0: "Field.Varint",
              _1: {
                TAG: /* Formatting_lit */ 17,
                _0: {
                  TAG: /* Break */ 0,
                  _0: "@ ",
                  _1: 1,
                  _2: 0
                },
                _1: /* End_of_format */ 0
              }
            }
          }
        },
        _1: "(@[<2>Field.Varint@ "
      });
      Curry._1(Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Int64 */ 7,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* Char_literal */ 12,
            _0: /* 'L' */76,
            _1: /* End_of_format */ 0
          }
        },
        _1: "%LdL"
      }), a0._0);
      return Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Formatting_lit */ 17,
          _0: /* Close_box */ 0,
          _1: {
            TAG: /* Char_literal */ 12,
            _0: /* ')' */41,
            _1: /* End_of_format */ 0
          }
        },
        _1: "@])"
      });
    case /* Varint_unboxed */ 1 :
      Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Char_literal */ 12,
          _0: /* '(' */40,
          _1: {
            TAG: /* Formatting_gen */ 18,
            _0: {
              TAG: /* Open_box */ 1,
              _0: {
                TAG: /* Format */ 0,
                _0: {
                  TAG: /* String_literal */ 11,
                  _0: "<2>",
                  _1: /* End_of_format */ 0
                },
                _1: "<2>"
              }
            },
            _1: {
              TAG: /* String_literal */ 11,
              _0: "Field.Varint_unboxed",
              _1: {
                TAG: /* Formatting_lit */ 17,
                _0: {
                  TAG: /* Break */ 0,
                  _0: "@ ",
                  _1: 1,
                  _2: 0
                },
                _1: /* End_of_format */ 0
              }
            }
          }
        },
        _1: "(@[<2>Field.Varint_unboxed@ "
      });
      Curry._1(Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: /* End_of_format */ 0
        },
        _1: "%d"
      }), a0._0);
      return Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Formatting_lit */ 17,
          _0: /* Close_box */ 0,
          _1: {
            TAG: /* Char_literal */ 12,
            _0: /* ')' */41,
            _1: /* End_of_format */ 0
          }
        },
        _1: "@])"
      });
    case /* Fixed_64_bit */ 2 :
      Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Char_literal */ 12,
          _0: /* '(' */40,
          _1: {
            TAG: /* Formatting_gen */ 18,
            _0: {
              TAG: /* Open_box */ 1,
              _0: {
                TAG: /* Format */ 0,
                _0: {
                  TAG: /* String_literal */ 11,
                  _0: "<2>",
                  _1: /* End_of_format */ 0
                },
                _1: "<2>"
              }
            },
            _1: {
              TAG: /* String_literal */ 11,
              _0: "Field.Fixed_64_bit",
              _1: {
                TAG: /* Formatting_lit */ 17,
                _0: {
                  TAG: /* Break */ 0,
                  _0: "@ ",
                  _1: 1,
                  _2: 0
                },
                _1: /* End_of_format */ 0
              }
            }
          }
        },
        _1: "(@[<2>Field.Fixed_64_bit@ "
      });
      Curry._1(Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Int64 */ 7,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* Char_literal */ 12,
            _0: /* 'L' */76,
            _1: /* End_of_format */ 0
          }
        },
        _1: "%LdL"
      }), a0._0);
      return Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Formatting_lit */ 17,
          _0: /* Close_box */ 0,
          _1: {
            TAG: /* Char_literal */ 12,
            _0: /* ')' */41,
            _1: /* End_of_format */ 0
          }
        },
        _1: "@])"
      });
    case /* Length_delimited */ 3 :
      const match = a0._0;
      const adata = match.data;
      const alength = match.length;
      const aoffset = match.offset;
      Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Formatting_gen */ 18,
          _0: {
            TAG: /* Open_box */ 1,
            _0: {
              TAG: /* Format */ 0,
              _0: {
                TAG: /* String_literal */ 11,
                _0: "<2>",
                _1: /* End_of_format */ 0
              },
              _1: "<2>"
            }
          },
          _1: {
            TAG: /* String_literal */ 11,
            _0: "Field.Length_delimited {",
            _1: {
              TAG: /* Formatting_lit */ 17,
              _0: {
                TAG: /* Break */ 0,
                _0: "@,",
                _1: 0,
                _2: 0
              },
              _1: /* End_of_format */ 0
            }
          }
        },
        _1: "@[<2>Field.Length_delimited {@,"
      });
      Curry._1(Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Formatting_gen */ 18,
          _0: {
            TAG: /* Open_box */ 1,
            _0: {
              TAG: /* Format */ 0,
              _0: /* End_of_format */ 0,
              _1: ""
            }
          },
          _1: {
            TAG: /* String */ 2,
            _0: /* No_padding */ 0,
            _1: {
              TAG: /* String_literal */ 11,
              _0: " =",
              _1: {
                TAG: /* Formatting_lit */ 17,
                _0: {
                  TAG: /* Break */ 0,
                  _0: "@ ",
                  _1: 1,
                  _2: 0
                },
                _1: /* End_of_format */ 0
              }
            }
          }
        },
        _1: "@[%s =@ "
      }), "offset");
      Curry._1(Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: /* End_of_format */ 0
        },
        _1: "%d"
      }), aoffset);
      Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Formatting_lit */ 17,
          _0: /* Close_box */ 0,
          _1: /* End_of_format */ 0
        },
        _1: "@]"
      });
      Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Char_literal */ 12,
          _0: /* ';' */59,
          _1: {
            TAG: /* Formatting_lit */ 17,
            _0: {
              TAG: /* Break */ 0,
              _0: "@ ",
              _1: 1,
              _2: 0
            },
            _1: /* End_of_format */ 0
          }
        },
        _1: ";@ "
      });
      Curry._1(Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Formatting_gen */ 18,
          _0: {
            TAG: /* Open_box */ 1,
            _0: {
              TAG: /* Format */ 0,
              _0: /* End_of_format */ 0,
              _1: ""
            }
          },
          _1: {
            TAG: /* String */ 2,
            _0: /* No_padding */ 0,
            _1: {
              TAG: /* String_literal */ 11,
              _0: " =",
              _1: {
                TAG: /* Formatting_lit */ 17,
                _0: {
                  TAG: /* Break */ 0,
                  _0: "@ ",
                  _1: 1,
                  _2: 0
                },
                _1: /* End_of_format */ 0
              }
            }
          }
        },
        _1: "@[%s =@ "
      }), "length");
      Curry._1(Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Int */ 4,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: /* End_of_format */ 0
        },
        _1: "%d"
      }), alength);
      Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Formatting_lit */ 17,
          _0: /* Close_box */ 0,
          _1: /* End_of_format */ 0
        },
        _1: "@]"
      });
      Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Char_literal */ 12,
          _0: /* ';' */59,
          _1: {
            TAG: /* Formatting_lit */ 17,
            _0: {
              TAG: /* Break */ 0,
              _0: "@ ",
              _1: 1,
              _2: 0
            },
            _1: /* End_of_format */ 0
          }
        },
        _1: ";@ "
      });
      Curry._1(Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Formatting_gen */ 18,
          _0: {
            TAG: /* Open_box */ 1,
            _0: {
              TAG: /* Format */ 0,
              _0: /* End_of_format */ 0,
              _1: ""
            }
          },
          _1: {
            TAG: /* String */ 2,
            _0: /* No_padding */ 0,
            _1: {
              TAG: /* String_literal */ 11,
              _0: " =",
              _1: {
                TAG: /* Formatting_lit */ 17,
                _0: {
                  TAG: /* Break */ 0,
                  _0: "@ ",
                  _1: 1,
                  _2: 0
                },
                _1: /* End_of_format */ 0
              }
            }
          }
        },
        _1: "@[%s =@ "
      }), "data");
      if (alength < 20) {
        Curry._1(Stdlib__Format.fprintf(fmt)({
          TAG: /* Format */ 0,
          _0: {
            TAG: /* Caml_string */ 3,
            _0: /* No_padding */ 0,
            _1: /* End_of_format */ 0
          },
          _1: "%S"
        }), Stdlib__String.sub(adata, aoffset, alength));
      } else {
        Curry._1(Stdlib__Format.fprintf(fmt)({
          TAG: /* Format */ 0,
          _0: {
            TAG: /* Caml_string */ 3,
            _0: /* No_padding */ 0,
            _1: {
              TAG: /* String_literal */ 11,
              _0: "...",
              _1: /* End_of_format */ 0
            }
          },
          _1: "%S..."
        }), Stdlib__String.sub(adata, aoffset, 17));
      }
      Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Formatting_lit */ 17,
          _0: /* Close_box */ 0,
          _1: /* End_of_format */ 0
        },
        _1: "@]"
      });
      return Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Formatting_lit */ 17,
          _0: /* Close_box */ 0,
          _1: {
            TAG: /* Char_literal */ 12,
            _0: /* '}' */125,
            _1: /* End_of_format */ 0
          }
        },
        _1: "@]}"
      });
    case /* Fixed_32_bit */ 4 :
      Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Char_literal */ 12,
          _0: /* '(' */40,
          _1: {
            TAG: /* Formatting_gen */ 18,
            _0: {
              TAG: /* Open_box */ 1,
              _0: {
                TAG: /* Format */ 0,
                _0: {
                  TAG: /* String_literal */ 11,
                  _0: "<2>",
                  _1: /* End_of_format */ 0
                },
                _1: "<2>"
              }
            },
            _1: {
              TAG: /* String_literal */ 11,
              _0: "Field.Fixed_32_bit",
              _1: {
                TAG: /* Formatting_lit */ 17,
                _0: {
                  TAG: /* Break */ 0,
                  _0: "@ ",
                  _1: 1,
                  _2: 0
                },
                _1: /* End_of_format */ 0
              }
            }
          }
        },
        _1: "(@[<2>Field.Fixed_32_bit@ "
      });
      Curry._1(Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Int32 */ 5,
          _0: /* Int_d */ 0,
          _1: /* No_padding */ 0,
          _2: /* No_precision */ 0,
          _3: {
            TAG: /* Char_literal */ 12,
            _0: /* 'l' */108,
            _1: /* End_of_format */ 0
          }
        },
        _1: "%ldl"
      }), a0._0);
      return Stdlib__Format.fprintf(fmt)({
        TAG: /* Format */ 0,
        _0: {
          TAG: /* Formatting_lit */ 17,
          _0: /* Close_box */ 0,
          _1: {
            TAG: /* Char_literal */ 12,
            _0: /* ')' */41,
            _1: /* End_of_format */ 0
          }
        },
        _1: "@])"
      });
  }
}

const show = Curry._1(Stdlib__Format.asprintf({
  TAG: /* Format */ 0,
  _0: {
    TAG: /* Alpha */ 15,
    _0: /* End_of_format */ 0
  },
  _1: "%a"
}), pp);

export {
  varint,
  varint_unboxed,
  fixed_32_bit,
  fixed_64_bit,
  length_delimited,
  string_of_field_type,
  pp,
  show,
}
/* show Not a pure module */
